import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonModule } from '@angular/common';
import { DragDropDirective } from '@app//features/chat/directives/drag-drop.directive';
import { FlexLayoutModule } from '@angular/flex-layout';
// import { FullCalendarModule } from '@fullcalendar/angular';
import { IfRoleDirective } from './components/directives/if-role.directive';
import { LocaleDatePipe } from './utils/locale-date.pipe';
import { MaterialModule } from './material/material.module';
import { MillisecondsHoursPipe } from './utils/milliseconds-hours.pipe';
import { NgModule } from '@angular/core';
import { ScrollDirective } from './utils/scroll.directive';
import { TextFilterPipe } from './utils/text-filter.pipe';

@NgModule({
  declarations: [
    DragDropDirective,
    LocaleDatePipe,
    MillisecondsHoursPipe,
    ScrollDirective,
    TextFilterPipe,
    IfRoleDirective,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    // FullCalendarModule
  ],
  exports: [
    MaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    LocaleDatePipe,
    MillisecondsHoursPipe,
    ScrollDirective,
    DragDropDirective,
    TextFilterPipe,
    IfRoleDirective,
  ],
  entryComponents: [
  ]
})
export class SharedModule { }
